import { useEffect, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { getPagePermissions } from '@hooks/useUser/provider'
import { Input } from '@components/shared/Input'
import { PageIds } from '@hooks/useLayout/types'
import { RowBox } from '@components/shared/RowBox'
import { Select } from '@components/shared/Select'
import { Switch } from '@components/shared/Switch'
import { useUser } from '@hooks/useUser'
import { useUsers } from '@pages/Users/context'

import type { RegistrationDataFormProps } from './types'
import type { PermissionsItemProps } from '@pages/AccessProfile/context/types'

import * as S from './styles'

export const RegistrationDataForm = ({ data }: RegistrationDataFormProps) => {
  const { setValue } = useFormContext()

  const { userPermissionsData, userData } = useUser()
  const { usersData, isUsersLoading, updateUserAdmin, isUpdateUserAdminLoading } = useUsers()

  const [permissions, setPermissions] = useState<PermissionsItemProps | null>(null)

  const isSuperAdmin = data?.code === userData?.user.id

  const profilesOptions = useMemo(() => {
    return (
      usersData?.availableFilters?.profiles
        .map((profile) => ({
          value: profile.id,
          label: profile.profileDescription
        }))
        .filter((profile) => profile.value !== 0) || []
    )
  }, [usersData])

  useEffect(() => {
    const pagePermissions = getPagePermissions(PageIds.USERS)
    setPermissions(pagePermissions)
  }, [userPermissionsData])

  return (
    <>
      {!isSuperAdmin && (!!userPermissionsData?.isSuperAdmin || !!userPermissionsData?.isAdmin) && (
        <S.SwitchBox>
          <Switch
            name="isAdmin"
            label="Usuário administrador"
            onChange={(_, checked) => {
              setValue('isAdmin', checked)
              !!data?.code && updateUserAdmin(data?.code, checked)
            }}
            disabled={isUpdateUserAdminLoading}
          />
        </S.SwitchBox>
      )}

      <RowBox columns={4}>
        <Input name="userName" label="Nome completo" disabled />
        <Input name="userCode" label="Código do Usuário" disabled />
        <Input name="email" label="E-mail" disabled />
        <Input name="login" label="Login" disabled />
      </RowBox>

      <RowBox columns={2}>
        <Input name="role" label="Cargo" disabled />
        <Select
          name="profileDescription"
          label="Descrição do Perfil"
          placeholder="Selecione um Perfil"
          options={profilesOptions}
          disabled={isUsersLoading || !permissions?.canEdit}
        />
      </RowBox>
    </>
  )
}
